import { Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { ILeiContact } from 'types/leiTypes';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import leiContactApi, { leiContactApiInit } from 'services/lei/leiContact';

import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

import Osoba from './Osoba';

interface IKontaktZmena {}

const KontaktZmena: React.FC<IKontaktZmena> = () => {
    const { lei, NotificationComponent, aktivniFirma } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const { setLevel } = useProfily();
    const [loading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<ILeiContact | undefined>();
    const [submitData, setSubmitData] = useState<ILeiContact>();
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const { FIRMA_PLAIN, LEI_DETAIL } = routePathEnum;
    const baseURL = `${FIRMA_PLAIN}${aktivniFirma?.iducet}`;

    useEffect(() => {
        setLoading(false);
        if (lei?.idVarsymZadosti?.id && lei.contactData) {
            setFormData(lei.contactData);
        } else {
            setShowConfirmation(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        lei?.idVarsymZadosti?.id &&
            submitData &&
            leiContactApi('post', lei.idVarsymZadosti.varsym, lei.idVarsymZadosti.id, submitData).then(() => {
                NotificationComponent({
                    title: 'ZADOST_O_LEI',
                    description: 'ZADOST_ODESLANA',
                    type: ENotificationType.SUCCESS
                });
                navigateWorkaround(`${baseURL}${LEI_DETAIL}`);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitData]);

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text={'LEI_AKTUALIZACE_INFORMACE_OPR'} />
            {showConfirmation ? (
                <>
                    <TranslateText>LEI_CONTACT_UPDATE_CONFIRM</TranslateText>
                    <Row className="button-row">
                        <ButtonComponent
                            id="kontaktZmenaAnoBtn"
                            type="primary"
                            htmlType="button"
                            buttontext={'ANO'}
                            onClick={() => {
                                setLoading(true);
                                leiContactApiInit(lei?.idVarsymZadosti?.varsym || '0')
                                    .then(resp => {
                                        setLevel('lei', {
                                            ...lei,
                                            idVarsymZadosti: resp
                                        });
                                        leiContactApi('get', resp.varsym, resp.id || 0).then(data => {
                                            setFormData({
                                                ...data.osoba,
                                                soubory: []
                                            });
                                            setShowConfirmation(false);
                                        });
                                    })
                                    .finally(() => setLoading(false));
                            }}
                        />
                    </Row>
                </>
            ) : (
                formData && (
                    <Osoba
                        isEdit={true}
                        setEditData={setSubmitData}
                        formDataOsoba={formData}
                        formDataSpolecnost={lei?.data?.spolecnost}
                    />
                )
            )}
        </LoadingWrapper>
    );
};

export default KontaktZmena;
